import type { FaireProductEntity } from "../../entity_types/product";

export const catalog_prod_prod_15: FaireProductEntity = {
  token: "catalog_prod_prod-15",
  type: "product",
  name: "Reversible Pillow - Celebrate Everyday - Style 2",
  brandName: "Audrey's Home & Gift",
  imageUrl:
    "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=400&h=400&fit=crop",
  priceDollars: 40.43,
  msrpDollars: 101.08,
  sku: "CO0015",
  caseSize: 3,
  material: "Wood",
  collectionToken: "col_confetti-cake",
  isNew: false,
  isBestseller: false,
  isPreviouslyOrdered: false,
  inStock: true,
  stockLevel: 73,
  description: "Beautiful Confetti & Cake piece perfect for any home.",
  categoryTokens: ["catalog_cat_candles-holders"],
  tags: [],
  brandToken: "catalog_brand_audreys_home_gift",
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
